import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationAutomaticPreformattedByOntologyCreateRequest, ConfigurationAutomaticPreformattedByOntologyPatchInBatchRequest, ConfigurationAutomaticPreformattedByOntologyResponse } from '@/modules/configurationModule/detail/automation/preformatted/services/configuration-preformatted.dto'

class PreformattedConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationAutomaticPreformattedByOntologyResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationAutomaticPreformattedByOntologyResponse>>(`/configuration/laboratories/${laboratoryId}/automaticPreformattedByOntology`, filterModel, { params })
        return response.data
    }

    async getPreformattedById(laboratoryId: number, defaultPreformattedId: number): Promise<ConfigurationAutomaticPreformattedByOntologyResponse> {
        const response = await axios.get<ConfigurationAutomaticPreformattedByOntologyResponse>(`/configuration/laboratories/${laboratoryId}/automaticPreformattedByOntology/${defaultPreformattedId}`)
        return response.data
    }

    async createPreformatted(laboratoryId: number, request: ConfigurationAutomaticPreformattedByOntologyCreateRequest): Promise<ConfigurationAutomaticPreformattedByOntologyResponse> {
        const response = await axios.post<ConfigurationAutomaticPreformattedByOntologyResponse>(`/configuration/laboratories/${laboratoryId}/automaticPreformattedByOntology`, request)
        return response.data
    }

    async deletePreformatted(laboratoryId: number, automaticPreformattedByOntologyIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/automaticPreformattedByOntology/batch`, { data: automaticPreformattedByOntologyIds })
        return response.data
    }

    async patchPreformatted(laboratoryId: number, requests: ConfigurationAutomaticPreformattedByOntologyPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/automaticPreformattedByOntology/batch`, requests)
        return response.data
    }
}

export const preformattedConfigurationServices = new PreformattedConfigurationServices()
